import React from "react";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ProgressBar from "../../UI/ProgressBar";
import "./EventConfirmModal.css";
import "./EmailTemplates.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 720,
  maxWidth: "calc(100vw - 32px)",
  height: "90vh",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "20px 24px 24px",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const EmailTemplatePreviewModal = ({
  open,
  onClose,
  title = "Email preview",
  subject,
  html,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="email-template-preview-title">
      <Box sx={modalStyle} className="email-template-preview-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>
        <h2 id="email-template-preview-title">{title}</h2>
        {loading ? (
          <ProgressBar />
        ) : (
          <>
            <p className="email-template-preview-modal__subject">
              <span>Subject</span>
              {subject || "—"}
            </p>
            <div className="email-template-preview-modal__frame">
              <iframe
                title="Email template preview"
                sandbox=""
                srcDoc={html || "<p>No preview available.</p>"}
              />
            </div>
          </>
        )}
      </Box>
    </Modal>
  );
};
